import React from 'react'
import './Breadcrum.css'
import arrow_icon from '../Assets/breadcrum_arrow.png'

const Breadcrum = (props) => {
    const { product } = props;
    
    // Add safety check using optional chaining
    return (
        <div className='breadcrum'>
            HOME <img src={arrow_icon} alt="" loading="eager" decoding="async" width="8" height="8" /> SHOP <img src={arrow_icon} alt="" loading="eager" decoding="async" width="8" height="8" />
            {product?.category} <img src={arrow_icon} alt="" loading="eager" decoding="async" width="8" height="8" /> {product?.name}
        </div>
    )
}

export default Breadcrum
